import { createStore } from '@datorama/akita';
import type GlobalUI from './types';
import initialState from 'state/UI/default';

export interface UIState extends Partial<GlobalUI> {
   showModalAddActivitiesFromScoping: boolean;
}

const store = createStore<UIState>(initialState, { name: 'globalUI' });

export function createInitialState(): UIState {
   return {
      showModalAddActivitiesFromScoping: false,
   };
}

export default store;
